import {
  MousePointerClick,
  Heart,
  Users,
  Bot,
  Sparkles,
  MessageCircle,
  Shield,
  Zap,
  RotateCw,
  Shirt,
  Gift,
  Crown,
  Rocket,
  Camera,
  Clapperboard,
} from "lucide-react";

export const POWERUP_ICONS = {
  mouse: MousePointerClick,
  heart: Heart,
  users: Users,
  bot: Bot,
  sparkles: Sparkles,
  "message-circle": MessageCircle,
  shield: Shield,
  zap: Zap,
  "rotate-cw": RotateCw,
  shirt: Shirt,
  gift: Gift,
  crown: Crown,
  rocket: Rocket,
  camera: Camera,
  clapperboard: Clapperboard,
} as const;
